var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01852 8.16732C3.73215 8.16732 3.5 7.64498 3.5 7.00065C3.5 6.35632 3.73215 5.83398 4.01852 5.83398H12.3148C12.6012 5.83398 12.8333 6.35632 12.8333 7.00065C12.8333 7.64498 12.6012 8.16732 12.3148 8.16732H4.01852ZM4.66667 15.1673C4.02233 15.1673 3.5 14.645 3.5 14.0007C3.5 13.3563 4.02233 12.834 4.66667 12.834H23.3333C23.9777 12.834 24.5 13.3563 24.5 14.0007C24.5 14.645 23.9777 15.1673 23.3333 15.1673H4.66667ZM15 21C15 21.5523 15.2239 22 15.5 22H23.5C23.7761 22 24 21.5523 24 21C24 20.4477 23.7761 20 23.5 20H15.5C15.2239 20 15 20.4477 15 21Z",
    fill: "#FF8400"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3011_37849",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 22,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01852 8.16732C3.73215 8.16732 3.5 7.64498 3.5 7.00065C3.5 6.35632 3.73215 5.83398 4.01852 5.83398H12.3148C12.6012 5.83398 12.8333 6.35632 12.8333 7.00065C12.8333 7.64498 12.6012 8.16732 12.3148 8.16732H4.01852ZM4.66667 15.1673C4.02233 15.1673 3.5 14.645 3.5 14.0007C3.5 13.3563 4.02233 12.834 4.66667 12.834H23.3333C23.9777 12.834 24.5 13.3563 24.5 14.0007C24.5 14.645 23.9777 15.1673 23.3333 15.1673H4.66667ZM15 21C15 21.5523 15.2239 22 15.5 22H23.5C23.7761 22 24 21.5523 24 21C24 20.4477 23.7761 20 23.5 20H15.5C15.2239 20 15 20.4477 15 21Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3011_37849)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.40e469beee03758bc4f742dc53319b13.svg";
export { ForwardRef as ReactComponent };